import posthog from 'posthog-js';

import { getStateOutsideOfComponent } from '#/reduxState/store';

/**
 * https://posthog.com/docs/libraries/next-js
 * https://posthog.com/docs/libraries/js/usage
 */
const trackEventInPosthog = (eventName: string, properties?: object) => {
  setTimeout(() => {
    posthog.capture(eventName, properties);
  });
};

const trackPageViewInPosthog = () => {
  setTimeout(() => {
    try {
      // TODO: katana is tracking initial view ?
      posthog.capture('$pageview');
    } catch (error) {
      // Possibly caused by aggressive ad-blocker
      console.warn(error);
    }
  });
};

// // GA: Initial page view is defined in `index.html`
export const trackPageView = (pathname: string): void => {
  setTimeout(() => {
    console.log(`[analytics] PAGEVIEW ${pathname}`);
    trackPageViewInPosthog();
    // trackGAPageView(pathname);
    // sendEventToChat('pageview', { value: pathname });
  }, 10);
};

// Event tracking document:
// https://docs.google.com/spreadsheets/d/1QP73840aGPo5Kl50PsQmSKlPioXqdr74CqpHwby0O4E
export const trackEvent = (category: string, properties?: object): void => {
  setTimeout(() => {
    getStateOutsideOfComponent().then(state => {
      const { gdprConsent } = state.userSettings;
      if (!gdprConsent || gdprConsent <= 0) {
        return;
      }
      console.log(`[analytics] TRACK ${category}`);

      trackEventInPosthog(category, properties);
      // addSentryBreadcrumb(category);

      // Just in case ga() is not fully asynchronous, to not block UI updates
      // sendEventToGA(category, { action /* , value */ });

      // Due to limitation of max number of events in Intercom, this will be disabled to prevent network error spam
      // if (sendToChat) { sendEventToChat(category, { action }); }
    });
  }, 10);
};

export const trackEventTyped = (
  eventObj:
    | {
        event: 'wallet_unlock_attempt' | 'wallet_unlock_success';
        walletType: string | null;
        walletDiscoveryRdns: string | undefined;
      }
    | {
        event: 'modal_open' | 'modal_close';
        title: string | undefined;
        size: string;
      }
    | {
        /** Legacy (crypto-js era) ciphertext decrypted - see lib/crypto/encryption */
        event: 'wallet_legacy_encryption_decrypt';
      }
): void => {
  const { event, ...props } = eventObj;
  trackEvent(event, props);
};

// Archived Google Analytics
// const trackGAPageView = (pathname: string): void => {
//   try {
//     if (!window.gtag) {
//       console.warn('Analytics unavailable [pageView]');
//       return;
//     }
//     const { protocol, hostname } = window.location;
//     window.gtag('set', 'page', pathname);
//     window.gtag('event', 'page_view', {
//       page_location: `${protocol}//${hostname}${pathname}`,
//     });
//   } catch (error) {
//     // Possibly caused by aggressive ad-blocker
//     console.warn(error);
//   }
// };
// const sendEventToGA = (
//   category: string,
//   { action }: { action: string }
// ): void => {
//   try {
//     if (!window.gtag) {
//       console.warn('Analytics unavailable [event]');
//       return;
//     }
//     window.gtag('event', category, {
//       action,
//       // eventValue: value, // https://support.google.com/analytics/answer/1033068?hl=en
//       // eventLabel,
//     });
//   } catch (error) {
//     // Possibly caused by aggressive ad-blocker
//     console.warn(error);
//   }
// };
